var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          staticClass: "productTypeDialog planWordDialog",
          staticStyle: { "margin-top": "-10vh" },
          style: { "--left": _vm.left },
          attrs: {
            "before-close": _vm.closeDialog,
            "destroy-on-close": true,
            "close-on-click-modal": false,
            "append-to-body": true,
            title: "",
            visible: _vm.schemeShow,
            width: "500px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.schemeShow = $event
            },
          },
        },
        [
          _c("div", { staticClass: "Dialog-top" }, [
            _c("span", { staticClass: "schemeSharing" }, [_vm._v("方案分享")]),
          ]),
          _c(
            "div",
            { staticClass: "Radio-Before Export-Item" },
            [
              _c(
                "el-radio-group",
                {
                  staticClass: "Export-Item-Radio top-radio",
                  on: { change: _vm.exportTypeChange },
                  model: {
                    value: _vm.exportType,
                    callback: function ($$v) {
                      _vm.exportType = $$v
                    },
                    expression: "exportType",
                  },
                },
                [
                  _c("el-radio", { attrs: { label: 0 } }, [
                    _vm._v(" 团组报价单 "),
                  ]),
                  _c("el-radio", { attrs: { label: 1 } }, [
                    _vm._v(" 团组确认书 "),
                  ]),
                  _c("el-radio", { attrs: { label: 2 } }, [
                    _vm._v(" 出团说明书 "),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
          _c("div", { staticClass: "Bottom-Style" }, [
            _c(
              "span",
              { staticStyle: { "font-size": "14px", "font-weight": "300" } },
              [_vm._v("请选择所需显示的内容")]
            ),
            _c("div", { staticClass: "Left-Line" }),
            _c("div", { staticStyle: { "padding-left": "20px" } }, [
              _c("div", { staticClass: "Radio-Before Export-Item" }, [
                _c(
                  "div",
                  {
                    staticStyle: {
                      "padding-bottom": "10px",
                      "padding-top": "5px",
                    },
                  },
                  [
                    _c(
                      "el-checkbox",
                      {
                        staticClass: "checkBox",
                        staticStyle: { color: "#DB4E1A" },
                        attrs: {
                          indeterminate:
                            _vm.checkItemContent.programme.isIndeterminate,
                          disabled: "",
                        },
                        on: { change: _vm.handleCheckProgrammeAllChange },
                        model: {
                          value: _vm.checkItemContent.programme.checkAll,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.checkItemContent.programme,
                              "checkAll",
                              $$v
                            )
                          },
                          expression: "checkItemContent.programme.checkAll",
                        },
                      },
                      [
                        _c("svg-icon", {
                          staticClass: "iconExport",
                          attrs: { "icon-class": "exportAdd" },
                        }),
                        _vm._v(" 方案 "),
                        _c(
                          "span",
                          {
                            staticStyle: {
                              color: "#339900",
                              "font-size": "12px",
                              display: "inline-block",
                              transform: "scale(0.8)",
                            },
                          },
                          [_vm._v("可多选")]
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-checkbox-group",
                      {
                        staticStyle: {
                          height: "0.8rem",
                          display: "flex",
                          "flex-wrap": "wrap",
                          "align-items": "center",
                          "border-radius": "10px",
                          "padding-left": "2px",
                        },
                        on: { change: _vm.handleCheckedProgrammeChange },
                        model: {
                          value:
                            _vm.checkItemContent.programme.checkProgrammeItems,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.checkItemContent.programme,
                              "checkProgrammeItems",
                              $$v
                            )
                          },
                          expression:
                            "checkItemContent.programme.checkProgrammeItems",
                        },
                      },
                      _vm._l(
                        _vm.checkItemContent.programme.programmeArr,
                        function (item) {
                          return _c(
                            "el-checkbox",
                            {
                              key: item,
                              staticStyle: { width: "75px" },
                              attrs: { label: item },
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    item === 0
                                      ? "单人"
                                      : item === 1
                                      ? "总价"
                                      : item === 2
                                      ? "个人信息"
                                      : item === 3
                                      ? "公司信息"
                                      : item === 4
                                      ? "行程地图"
                                      : item === 5
                                      ? "特色推荐"
                                      : item === 6
                                      ? "参考酒店"
                                      : item === 7
                                      ? "参考餐厅"
                                      : "简要信息"
                                  ) +
                                  " "
                              ),
                            ]
                          )
                        }
                      ),
                      1
                    ),
                    _vm.tweetCount == 0
                      ? _c(
                          "span",
                          {
                            staticStyle: {
                              position: "relative",
                              top: "3.5px",
                              color: "#DB4E1A",
                            },
                          },
                          [
                            _c("i", {
                              staticClass: "el-icon-warning-outline",
                              staticStyle: { "padding-right": "2px" },
                            }),
                            _vm._v("该方案没有设置特推图"),
                            _c(
                              "a",
                              {
                                staticStyle: {
                                  "text-decoration": "underline",
                                  color: "#0A56BB",
                                },
                                on: { click: _vm.goSet },
                              },
                              [_vm._v("去添加")]
                            ),
                          ]
                        )
                      : _c(
                          "span",
                          {
                            staticStyle: {
                              position: "relative",
                              top: "3.5px",
                              color: "#DB4E1A",
                            },
                          },
                          [
                            _c("i", {
                              staticClass: "el-icon-warning-outline",
                              staticStyle: { "padding-right": "2px" },
                            }),
                            _vm._v("已有特推图"),
                            _c(
                              "a",
                              {
                                staticStyle: {
                                  "text-decoration": "underline",
                                  color: "#0A56BB",
                                },
                                on: { click: _vm.goSet },
                              },
                              [_vm._v("去修改")]
                            ),
                          ]
                        ),
                  ],
                  1
                ),
                _c(
                  "div",
                  [
                    _c(
                      "el-checkbox",
                      {
                        staticClass: "checkBox",
                        staticStyle: { color: "#DB4E1A" },
                        attrs: {
                          indeterminate:
                            _vm.checkItemContent.offer.isIndeterminate,
                          disabled: "",
                        },
                        on: { change: _vm.handleCheckOfferAllChange },
                        model: {
                          value: _vm.checkItemContent.offer.checkAll,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.checkItemContent.offer,
                              "checkAll",
                              $$v
                            )
                          },
                          expression: "checkItemContent.offer.checkAll",
                        },
                      },
                      [
                        _c("svg-icon", {
                          staticClass: "iconExport",
                          attrs: { "icon-class": "exportAdd" },
                        }),
                        _vm._v(" 报价 "),
                        _c(
                          "span",
                          {
                            staticStyle: {
                              color: "#339900",
                              "font-size": "12px",
                              display: "inline-block",
                              transform: "scale(0.8)",
                            },
                          },
                          [_vm._v("可多选")]
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-checkbox-group",
                      {
                        staticStyle: {
                          height: "30px",
                          display: "flex",
                          "align-items": "center",
                          "padding-left": "2px",
                          "border-radius": "10px",
                        },
                        on: { change: _vm.handleCheckedOfferChange },
                        model: {
                          value: _vm.checkItemContent.offer.checkOfferItems,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.checkItemContent.offer,
                              "checkOfferItems",
                              $$v
                            )
                          },
                          expression: "checkItemContent.offer.checkOfferItems",
                        },
                      },
                      _vm._l(
                        _vm.checkItemContent.offer.offerArr,
                        function (item) {
                          return _c(
                            "el-checkbox",
                            { key: item, attrs: { label: item } },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    item === 2
                                      ? "单价"
                                      : item === 1
                                      ? "总价"
                                      : "单人"
                                  ) +
                                  " "
                              ),
                            ]
                          )
                        }
                      ),
                      1
                    ),
                  ],
                  1
                ),
              ]),
              _c(
                "div",
                {
                  staticClass: "applets-style",
                  staticStyle: { "margin-top": "6px" },
                },
                [
                  _c("div", { staticClass: "Radio-Before" }, [
                    _c(
                      "span",
                      {
                        staticStyle: {
                          "font-size": "12px",
                          "font-weight": "bolder",
                        },
                      },
                      [
                        _c("svg-icon", {
                          staticClass: "iconExport",
                          attrs: { "icon-class": "exportAdd" },
                        }),
                        _vm._v(" 说明 "),
                        _c(
                          "span",
                          {
                            staticStyle: {
                              color: "#339900",
                              "font-size": "12px",
                              display: "inline-block",
                              transform: "scale(0.8)",
                            },
                          },
                          [_vm._v("单选")]
                        ),
                      ],
                      1
                    ),
                    _c(
                      "span",
                      {
                        staticStyle: {
                          "text-decoration": "underline",
                          display: "inline-block",
                          transform: "scale(0.8)",
                          "border-radius": "10px",
                          color: "rgb(219, 78, 26)",
                        },
                        attrs: { type: "" },
                        on: { click: _vm.handlerOrganizationSetClick },
                      },
                      [_vm._v("点击新增")]
                    ),
                  ]),
                  _c(
                    "el-radio-group",
                    {
                      staticClass: "custom-radio",
                      on: { change: _vm.changeRadio },
                      model: {
                        value: _vm.schemeRadio,
                        callback: function ($$v) {
                          _vm.schemeRadio = $$v
                        },
                        expression: "schemeRadio",
                      },
                    },
                    _vm._l(_vm.schemeData, function (item, index) {
                      return _c(
                        "el-radio",
                        {
                          key: index,
                          attrs: { label: item.id },
                          nativeOn: {
                            click: function ($event) {
                              $event.preventDefault()
                              return _vm.changeRadio(item.id)
                            },
                          },
                        },
                        [_vm._v(_vm._s(item.schemeName) + " ")]
                      )
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "Radio-Before" },
                [
                  _c("svg-icon", {
                    staticClass: "iconExport",
                    attrs: { "icon-class": "exportAdd" },
                  }),
                  _c(
                    "el-link",
                    {
                      staticStyle: {
                        "font-size": "12px",
                        "font-weight": "bolder",
                      },
                      on: { click: _vm.preview },
                    },
                    [_vm._v("点击预览")]
                  ),
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "Radio-Before Export-Item-File" },
                [
                  _c("svg-icon", {
                    staticClass: "iconExport bigIcon",
                    attrs: { "icon-class": "exportRight" },
                  }),
                  _c("div", { staticClass: "Item-File" }, [
                    _c(
                      "div",
                      [
                        _c("Qr", { attrs: { text: _vm.text } }),
                        _c(
                          "span",
                          {
                            staticStyle: {
                              display: "flex",
                              "justify-content": "center",
                              "margin-top": "5px",
                              "font-weight": "700",
                            },
                          },
                          [_vm._v("扫描查看手机版本")]
                        ),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      [
                        _c(
                          "el-radio-group",
                          {
                            staticClass: "Export-Item-Radio-Download",
                            on: { change: _vm.versionExport },
                            model: {
                              value: _vm.itemFileType,
                              callback: function ($$v) {
                                _vm.itemFileType = $$v
                              },
                              expression: "itemFileType",
                            },
                          },
                          _vm._l(
                            _vm.exportContent[_vm.exportType].itemFileTypeArr,
                            function (item, index) {
                              return _c(
                                "el-radio",
                                {
                                  key: index,
                                  staticStyle: { width: "230px" },
                                  attrs: { label: item.value },
                                },
                                [
                                  _c(
                                    "svg",
                                    {
                                      staticClass: "icon",
                                      staticStyle: {
                                        position: "relative",
                                        top: "6px",
                                      },
                                      attrs: {
                                        t: "1728568808301",
                                        viewBox: "0 0 1024 1024",
                                        version: "1.1",
                                        xmlns: "http://www.w3.org/2000/svg",
                                        "p-id": "5156",
                                        width: "200",
                                        height: "200",
                                      },
                                    },
                                    [
                                      _c("path", {
                                        attrs: {
                                          d: "M833.841473 336.403925c-29.237791-149.914232-160.920736-263.309448-321.841473-263.309448S219.452762 186.489692 190.158527 336.403925C80.48859 365.641715 0 468.030427 0 585.038033c0 142.633006 113.395216 256.028222 255.971778 256.028222h36.57546v-73.15092h-36.57546c-102.388711 0-182.877301-80.432146-182.877301-182.877302 0-102.388711 80.432146-182.877301 182.877301-182.877301 0-142.633006 113.395216-255.971778 255.971778-255.971778 142.633006 0 256.028222 113.395216 256.028222 255.971778 102.388711 0 182.877301 80.432146 182.877301 182.877301 0 102.388711-80.432146 182.877301-182.877301 182.877302h-36.57546v73.15092h36.57546c142.633006 0 255.971778-113.395216 255.971778-256.028222 0.056444-117.007607-80.432146-219.396318-190.102083-248.634108z",
                                          "p-id": "5157",
                                        },
                                      }),
                                      _c("path", {
                                        attrs: {
                                          d: "M599.769816 782.53423l-43.856686 40.244295V511.943556c0-21.956565-18.28773-36.57546-36.575461-36.57546-21.956565 0-36.57546 18.28773-36.57546 36.57546v310.834969l-43.91313-40.244295c-14.618895-14.618895-40.244295-14.618895-54.86319 0-14.618895 14.618895-14.618895 36.57546 0 51.194356l109.726381 106.057546c3.668835 3.668835 7.337669 7.337669 10.950061 7.337669 14.618895 7.337669 29.237791 3.668835 40.244295-7.337669l106.057546-106.057546c14.618895-14.618895 14.618895-36.57546 0-51.194356-10.950061-14.618895-36.57546-14.618895-51.194356 0z",
                                          "p-id": "5158",
                                        },
                                      }),
                                    ]
                                  ),
                                  _c("span", {
                                    staticStyle: {
                                      "font-size": "12px !important",
                                      "margin-left": "3px",
                                    },
                                    domProps: { innerHTML: _vm._s(item.name) },
                                  }),
                                  _vm.itemFileType === item.value
                                    ? _c("span", { staticClass: "checked" }, [
                                        _c("i", {
                                          staticClass: "el-icon-loading",
                                          staticStyle: {
                                            position: "absolute",
                                            "font-weight": "700",
                                            top: "10px",
                                            left: "-25px",
                                          },
                                        }),
                                      ])
                                    : _vm._e(),
                                ]
                              )
                            }
                          ),
                          1
                        ),
                        _c("mapCanvas", {
                          staticStyle: {
                            display: "flex",
                            "justify-content": "center",
                            "margin-top": "5px",
                          },
                        }),
                        _vm.showPlanSendButton && _vm.showPlanSendButton != ""
                          ? _c(
                              "el-button",
                              {
                                staticClass: "Send-Sheceme",
                                attrs: { type: "", size: "mini" },
                                on: { click: _vm.sendPlan },
                              },
                              [_vm._v("发送方案给客户 ")]
                            )
                          : _vm._e(),
                      ],
                      1
                    ),
                  ]),
                ],
                1
              ),
            ]),
          ]),
        ]
      ),
      _c("offerDetailPopup", { ref: "offerPopup" }),
      _c("H5PlanIframe", { ref: "h5PlanIframe" }),
      _c("tweet-image-dialog", {
        ref: "tweetImage",
        staticClass: "tweet-image-dialog",
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }